import { useEffect } from "react";
import toast from "react-hot-toast";

/**
 * Toast messages hook
 *
 * @param {Object} flash - The flash message object containing notice or alert.
 */
export default function useToast(flash) {
  useEffect(() => {
    if (!flash) return;

    const type = flash.notice ? "success" : flash.alert ? "error" : null;
    const message = flash.notice || flash.alert;

    if (!type || !message) return;

    const timer = setTimeout(() => {
      toast[type](message);
    }, 500);

    return () => clearTimeout(timer);
  }, [flash, toast]);

  return {
    toast,
  };
}
